import { jsxs as g, jsx as n } from "react/jsx-runtime";
import { d as w } from "../../vendor-CPVnY93G.js";
import { forwardRef as _ } from "react";
import { BaseIcon as x } from "../BaseIcon/index.js";
import { TooltipTrigger as I, Tooltip as j } from "../Tooltip/index.js";
import '../../assets/index41.css';const b = "_infoTooltip_nlf9t_1", h = "_warning_nlf9t_10", i = {
  infoTooltip: b,
  warning: h
}, W = _(
  ({ children: r, placement: t, variant: a = "info", size: s = "md", id: f, m: l, mt: m, mr: p, mb: c, ml: e, ...T }, d) => {
    const o = a === "warning";
    return /* @__PURE__ */ g(I, { delay: "immediate", children: [
      /* @__PURE__ */ n(
        x,
        {
          size: s,
          id: f,
          m: l,
          mt: m,
          mr: p,
          mb: c,
          ml: e,
          ref: d,
          color: o ? "sienna" : "moon",
          className: w(i.infoTooltip, o && i.warning),
          icon: "info",
          description: T["aria-label"],
          "data-component": "InfoTooltip"
        }
      ),
      /* @__PURE__ */ n(j, { placement: t, children: r })
    ] });
  }
);
export {
  W as InfoTooltip
};
